import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "primereact/button";
import { useDispatch } from "react-redux";
import "./reset.scss";
import { handlePostRequest } from "../services/PostTemplate";
import { ToastContainer, toast } from "react-toastify";

const STATUS = { CHECKING: "checking", VERIFIED: "verified", ERROR: "error" };

function Verify() {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const token = new URLSearchParams(location.search).get("token");
    const [status, setStatus] = useState(STATUS.CHECKING);
    const [resendEmail, setResendEmail] = useState("");
    const [resending, setResending] = useState(false);

    useEffect(() => {
        const verify = async () => {
            if (!token) {
                setStatus(STATUS.ERROR);
                return;
            }
            const res = await dispatch(handlePostRequest({ token }, "/verifyEmail"));
            setStatus(res !== "error" && res?.success ? STATUS.VERIFIED : STATUS.ERROR);
        };
        verify();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleResend = async () => {
        if (!resendEmail.trim()) {
            toast.error("Please enter your email address.");
            return;
        }
        setResending(true);
        try {
            const res = await dispatch(handlePostRequest({ email: resendEmail.trim() }, "/resendVerification"));
            if (res !== "error") {
                toast.success("If that email has a pending verification, a new link has been sent.");
            }
        } finally {
            setResending(false);
        }
    };

    return (
        <>
            <ToastContainer />
            <div className="reset_body">
                <div className="reset_container">
                    <div className="logo_section">
                        <img src="https://res.cloudinary.com/dwxqg9so3/image/upload/v1758210476/4wd_logo_big_croped_djegsi.jpg" alt="Move4wd Logo" className="reset_logo" />
                    </div>

                    <div className="reset_content">
                        {status === STATUS.CHECKING && (
                            <>
                                <h1 className="reset_header">Verifying your email...</h1>
                                <p className="reset_sub_header">Just a moment while we confirm your email address.</p>
                            </>
                        )}

                        {status === STATUS.VERIFIED && (
                            <>
                                <h1 className="reset_header">Email Verified</h1>
                                <p className="reset_sub_header">Your email has been confirmed. You can now log in to your account.</p>
                                <div className="button_wrapper">
                                    <Button className="reset_button" label="Log In" onClick={() => history.push("/login")} />
                                </div>
                            </>
                        )}

                        {status === STATUS.ERROR && (
                            <>
                                <h1 className="reset_header">Link Invalid or Expired</h1>
                                <p className="reset_sub_header">This verification link is invalid or has expired. Enter your email below to get a new one.</p>
                                <div className="reset_form">
                                    <div className="input_wrapper">
                                        <input className="reset_input" placeholder="Enter your email address" value={resendEmail} onChange={(e) => setResendEmail(e.target.value)} type="email" />
                                    </div>
                                    <div className="button_wrapper">
                                        <Button className="reset_button" label="Resend Verification Email" icon={resending ? "pi pi-spin pi-spinner" : ""} iconPos="right" disabled={resending} onClick={handleResend} />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Verify;
